import { useFeatureFlag } from '@src/hooks/useFeatureFlag';
import { isTalosUser, parseDate, useUserContext } from '@talos/kyoko';
import { useMemo } from 'react';

/**
 * Determines if the user can use Daily Analytics features.
 */
export function useCanUseDailyAnalytics(): boolean {
  const { enableDailyAnalytics, dailyAnalyticsTrialEndDate } = useFeatureFlag();
  const { user } = useUserContext();

  return useMemo(() => {
    if (!enableDailyAnalytics) {
      return false;
    }

    if (isTalosUser(user)) {
      return true;
    }

    const trialEndDateStr = dailyAnalyticsTrialEndDate?.trim();

    if (!trialEndDateStr) {
      return true;
    }

    const parsedTrialEndDate = parseDate(trialEndDateStr);
    const now = parseDate();

    if (isNaN(parsedTrialEndDate.getTime())) {
      return false;
    }

    if (parsedTrialEndDate < now) {
      return false;
    }

    return true;
  }, [enableDailyAnalytics, dailyAnalyticsTrialEndDate, user]);
}
